import {AfterContentInit, Component, Injector, inject, input, contentChildren, DestroyRef, ChangeDetectionStrategy} from "@angular/core"
import {ActionItemComponent} from "@common/components/menu/actions/action-item/action-item.component"
import {outputToObservable, toObservable, takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-action-bar",
    templateUrl: "./action-bar.component.html",
    styleUrls: ["./action-bar.component.scss"],
    imports: [],
})
export class ActionBarComponent implements AfterContentInit {
    private injector = inject(Injector)
    private readonly destroyRef = inject(DestroyRef)
    readonly actionItems = contentChildren(ActionItemComponent)
    readonly $visible = input(true, {alias: "visible"})
    readonly $activeItem = input<ActionItemComponent>(undefined, {alias: "activeItem"})

    ngAfterContentInit() {
        for (const actionItem of this.actionItems()) {
            outputToObservable(actionItem.itemClick)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                    if (actionItem.$panel() == null) return
                    this.actionItems().forEach((item) => (item.$panel() != null && item != actionItem ? item.$active.set(false) : null))
                })
            toObservable(actionItem.$active, {injector: this.injector})
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((active) => {
                    if (!active) return
                    this.actionItems().forEach((item) => (item.$panel() != null && item != actionItem ? item.$active.set(false) : null))
                })
        }
    }
}
